import React, { useState, useEffect } from "react";

function SearchModelTypeCheckboxes({ value, onChange }) {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    // Show warning if no checkboxes are selected
    setShowWarning(value.length === 0);
  }, [value]);

  const handleChange = (event) => {
    const { value: checkboxValue, checked } = event.target;
    let updatedModelTypes;

    if (checked) {
      updatedModelTypes = [...value, checkboxValue];
    } else {
      updatedModelTypes = value.filter((type) => type !== checkboxValue);
    }

    onChange(updatedModelTypes);
  };

  const handleSelectAll = (event) => {
    event.preventDefault();
    const allModelTypes = [
      "Id::CompanyJob",
      "Id::MediaItem",
      "Id::MediaJob",
      "Id::MediaOutlet",
      "Id::Profile::MediaProfile",
      "Id::Profile::Promoter",
      "Id::PromoEntity::Company",
      "Id::PromoEntity::Expert",
      "Id::PromoEntity::Product",
      "Id::Quote",
      "Interact::Pitch",
      "Interact::Request",
      "Enrich::PublicPitch",
    ];
    onChange(allModelTypes);
  };

  const handleDeselectAll = (event) => {
    event.preventDefault();
    onChange([]);
  };

  return (
    <div className="mb-3">
      <label htmlFor="embedding-types-group" className="form-label">
        Search Model Types
      </label>
      <div id="embedding-types-group" className="d-flex flex-wrap" aria-labelledby="embedding-types-label">
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Id::CompanyJob"
            id="companyJobCheckbox"
            checked={value.includes("Id::CompanyJob")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="companyJobCheckbox">
            Company Job
          </label>
        </div>
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Id::MediaItem"
            id="mediaItemCheckbox"
            checked={value.includes("Id::MediaItem")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="mediaItemCheckbox">
            Media Item
          </label>
        </div>
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Id::MediaJob"
            id="mediaJobCheckbox"
            checked={value.includes("Id::MediaJob")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="mediaJobCheckbox">
            Media Job
          </label>
        </div>
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Id::MediaOutlet"
            id="mediaOutletCheckbox"
            checked={value.includes("Id::MediaOutlet")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="mediaOutletCheckbox">
            Media Outlet
          </label>
        </div>
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Id::Profile::MediaProfile"
            id="mediaProfileCheckbox"
            checked={value.includes("Id::Profile::MediaProfile")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="mediaProfileCheckbox">
            Media Profile
          </label>
        </div>
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Id::Profile::Promoter"
            id="promoterProfileCheckbox"
            checked={value.includes("Id::Profile::Promoter")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="promoterProfileCheckbox">
            Promoter Profile
          </label>
        </div>
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Id::PromoEntity::Company"
            id="promoCompanyCheckbox"
            checked={value.includes("Id::PromoEntity::Company")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="promoCompanyCheckbox">
            Promo Company
          </label>
        </div>
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Id::PromoEntity::Expert"
            id="promoExpertCheckbox"
            checked={value.includes("Id::PromoEntity::Expert")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="promoExpertCheckbox">
            Promo Expert
          </label>
        </div>
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Id::PromoEntity::Product"
            id="promoProductCheckbox"
            checked={value.includes("Id::PromoEntity::Product")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="promoProductCheckbox">
            Promo Product
          </label>
        </div>
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Id::Quote"
            id="quoteCheckbox"
            checked={value.includes("Id::Quote")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="quoteCheckbox">
            Quote
          </label>
        </div>
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Interact::Pitch"
            id="pitchCheckbox"
            checked={value.includes("Interact::Pitch")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="pitchCheckbox">
            Pitch
          </label>
        </div>
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Interact::Request"
            id="requestCheckbox"
            checked={value.includes("Interact::Request")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="requestCheckbox">
            Request
          </label>
        </div>
        <div className="form-check me-2">
          <input
            className="form-check-input"
            type="checkbox"
            value="Enrich::PublicPitch"
            id="publicPitchCheckbox"
            checked={value.includes("Enrich::PublicPitch")}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="publicPitchCheckbox">
            Public Pitch
          </label>
        </div>
      </div>
      <div className="btn-group btn-group-sm mb-0">
        <button className="btn btn-link ps-0 pb-0" type="button" onClick={handleSelectAll}>
          Select All
        </button>
        <button className="btn btn-link pb-0" type="button" onClick={handleDeselectAll}>
          None
        </button>
      </div>
      {showWarning && (
        <div className="text-warning">
          At least one type must be selected. Default value (which is all) will be applied.
        </div>
      )}
    </div>
  );
}

export default SearchModelTypeCheckboxes;
